import React, { useMemo, Fragment, useState, useEffect } from "react";
import { Link, redirect, useNavigate } from "react-router-dom";
import { Row, Col, Card, Form, Button, Modal } from "react-bootstrap";
import {
  bulkUserUpload,
  createUser,
  createUserGroup,
  getCourses,
  getSignedUrl,
  getUsers,
} from "ServerAPI/serverAPI";
import { useCookies } from "react-cookie";
import TanstackTable from "components/elements/advance-table/TanstackTable";
import CommonHeader from "layouts/dashboard/CommonHeader";
import userGroupIcon from "../../assets/images/user/Usergroup_illustration.svg";
import Multiselect from "multiselect-react-dropdown";
import _ from "lodash";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";

const AddUserGroup = () => {
  const columns = useMemo(
    () => [
      {
        accessorKey: "slNo",
        header: "Sl. No.",
      },
      {
        accessorKey: "name",
        header: "Name",
      },
      {
        accessorKey: "email",
        header: "Email",
      },
      {
        accessorKey: "phone",
        header: "Phone",
      },
    ],
    []
  );

  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState("");

  const [selectedCourseName, setSelectedCourseName] = useState("");
  const [file, setFile] = useState(null);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [programCoordinators, setProgramCoordinators] = useState([]);
  const [downloadTemplateLoading, setDownloadTemplateLoading] = useState(false);
  const [fetchCoursesLoading, setFetchCoursesLoading] = useState(false);
  const navigate = useNavigate();

  const handleModalClose = () => {
    setFile(null);
    setShowModal(false);
  };

  const [userData, setUserData] = useState([]);
  const [cookies, setCookies] = useCookies();

  const [formData, setFormData] = useState({
    groupName: "",
    subProcess: "",
    startDate: "",
    endDate: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({
    groupName: "",
    selectedCourse: "",
    userData: "",
    uploadError: "",
    pcSelectionError: ",",
  });
  const [success, setSuccess] = useState(false);
  const [courseList, setCourseList] = useState([]);
  const [selectedProgramCoordinator, setSelectedProgramCoordinator] =
    useState("");

  const userFields = [
    { label: "Program Name", type: "text", name: "groupName" },
    {
      label: "Courses",
      type: "dropdown",
      name: "subProcess",
      options: courseList || [],
    },
    {
      label: "Start Date",
      type: "date",
      name: "startDate",
    },
    {
      label: "End Date",
      type: "date",
      name: "endDate",
    },
  ];

  // Handle form field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Single User creation
  const handleSubmit = async (e) => {
    e.preventDefault();

    let isValid = true;

    const newError = {
      groupName: "",
      selectedCourse: "",
      userData: "",
      uploadError: "",
      pcSelectionError: "",
      startDate: "",
      endDate: "",
    };

    if (!formData.groupName) {
      newError.groupName = "Username is required";
      isValid = false;
    }
    if (!formData.startDate) {
      newError.startDate = "Start Date is required";
      isValid = false;
    }
    if (!formData.endDate) {
      newError.endDate = "End Date is required";
      isValid = false;
    }

    if (selectedCourses.length <= 0) {
      newError.selectedCourse = "Select course/courses";
      isValid = false;
    }

    if (userData.length <= 0) {
      newError.userData = "Add users, users cannot be empty";
      isValid = false;
    }

    setError(newError);
    if (!isValid) {
      return;
    }

    setLoading(true);
    setSuccess(false);
    const body = {
      userGroupName: formData.groupName,
      courseIds: selectedCourses,
      courseTitles: selectedCourseName,
      userIds: userData.map((user) => user.id),
      organizationId: cookies.organizationId,
      authorUserId:
        cookies.roleId === "programCoordinator"
          ? cookies.userId
          : selectedProgramCoordinator,
      // email: cookies.email,
      // programCoordinatorEmail: cookies.email,
      // programCoordinatorUserId: cookies.userId,
      // programCoordinatorName: cookies.name,
      startDate: new Date(formData.startDate).toISOString(),
      endDate: new Date(formData.endDate).toISOString(),
    };

    const res = await createUserGroup(body);
    res && setSuccess(true);
    setLoading(false);
    navigate("/user-groups");
  };

  const fetchCourses = async () => {
    setFetchCoursesLoading(true);
    const email = cookies.email;
    const roleId = cookies.roleId;
    const organizationId = cookies.organizationId;
    const res = await getCourses(
      email,
      roleId,
      cookies.organizationId,
      cookies.department,
      cookies.userId
    );

    if (roleId !== "programCoordinator") {
      const users = await getUsers(email, roleId, organizationId);
      const pcData = users?.data?.users?.filter(
        (user) =>
          user?.role?.roleId === "programCoordinator" &&
          user?.organizationId === cookies?.organizationId
      );
      setProgramCoordinators(pcData);
    } else {
      setProgramCoordinators([]);
    }

    setCourseList(res.data);
    setFetchCoursesLoading(false);
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      const fileType = selectedFile.type;
      if (
        fileType ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        fileType === "application/vnd.ms-excel"
      ) {
        setFile(selectedFile);
        setError({ ...error, uploadError: "" });
      } else {
        setError({ ...error, uploadError: "Add valid excel file" });
      }
    }
  };

  const handleBulkUser = async () => {
    if (!file) {
      console.log("no file selected");
      setError({ ...error, uploadError: "Add excel file" });
      return;
    } else {
      setError({ ...error, uploadError: "" });
    }

    if (
      cookies.roleId !== "programCoordinator" &&
      !selectedProgramCoordinator
    ) {
      setError({
        ...error,
        pcSelectionError: "Please select Program Coordinator",
      });
      return;
    } else {
      setError({ ...error, pcSelectionError: "" });
    }

    const convertFileToBase64 = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(",")[1]); // Extract Base64 content
        reader.onerror = (error) => reject(error);
      });
    };

    const body = {
      file: await convertFileToBase64(file),
      organizationId: cookies.organizationId,
      department: cookies.department,
      userId:
        cookies.roleId === "programCoordinator"
          ? cookies.userId
          : selectedProgramCoordinator,
    };

    const response = await bulkUserUpload(body);
    const users = response?.data?.users?.map((user, index) => ({
      slNo: index + 1,
      id: user.userId,
      name: user.name,
      email: user.email,
      phone: user.phoneNumber,
    }));
    setUserData(users);
    setShowModal(false);
    setFile(null);
  };

  const handleCourseSelect = (value) => {
    setSelectedCourses(_.map(value, "courseId"));
    setSelectedCourseName(_.map(value, "courseTitle"));
  };
  const handleCourseRemove = (value) => {
    setSelectedCourses(_.map(value, "courseId"));
    setSelectedCourseName(_.map(value, "courseTitle"));
  };
  const downloadTemplate = async () => {
    setDownloadTemplateLoading(true);
    const payload = {
      method: "GET",
      downloadTemplate: true,
      fileName: "bulk_user_upload.xlsx",
      userId: cookies?.userId,
    };

    const response = await getSignedUrl(payload);
    if (response.status === 200) {
      const a = document.createElement("a");
      a.href = response?.data?.preSignedUrl;
      a.download = "bulk_user_upload.xlsx";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    setDownloadTemplateLoading(false);
  };

  return (
    <Fragment>
      <Row>
        <Col>
          <CommonHeader
            text="Create Training Program"
            subText="Create a new training program to manage and organize users effectively."
            icon={userGroupIcon}
          />
        </Col>
      </Row>
      {fetchCoursesLoading ? (
        <>
          <div className="d-flex justify-content-center mt-5">
            <CircularProgress />
          </div>
        </>
      ) : (
        <>
          <Row>
            <Col></Col>
            <Col xs={10} className="mx-auto pt-5">
              <Form noValidate onSubmit={handleSubmit}>
                <Card className="mb-4">
                  <Card.Body>
                    <Row className="">
                      {userFields.map((field, index) => (
                        <Form.Group
                          as={Col}
                          md={6}
                          controlId={field.name}
                          key={index}
                          className="mb-3"
                        >
                          <Form.Label>{field.label}</Form.Label>
                          {field.type === "dropdown" ? (
                            <>
                              <Multiselect
                                options={courseList}
                                //   selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                                onSelect={handleCourseSelect}
                                onRemove={handleCourseRemove}
                                displayValue="courseTitle"
                                placeholder="Select Courses"
                                showArrow={true}
                                showCheckbox={true}
                              />
                              {error.selectedCourse && (
                                <div className="text-danger">
                                  {error.selectedCourse}
                                </div>
                              )}
                            </>
                          ) : (
                            <>
                              <Form.Control
                                type={field.type}
                                placeholder={`Enter ${field.label}`}
                                name={field.name}
                                value={formData[field.name]}
                                onChange={handleChange}
                                required
                              />
                              {error.groupName &&
                                field.name === "groupName" && (
                                  <div className="text-danger">
                                    {error.groupName}
                                  </div>
                                )}
                              {error.startDate &&
                                field.name === "startDate" && (
                                  <div className="text-danger">
                                    {error?.startDate}
                                  </div>
                                )}
                              {error.endDate && field.name === "endDate" && (
                                <div className="text-danger">
                                  {error?.endDate}
                                </div>
                              )}
                            </>
                          )}
                        </Form.Group>
                      ))}
                    </Row>
                    {cookies.roleId !== "programCoordinator" && (
                      <Row className="mb-4">
                        <Col xs={6}>
                          <Form.Label>Program Coordinator</Form.Label>
                          <Form.Select
                            value={selectedProgramCoordinator}
                            onChange={(e) =>
                              setSelectedProgramCoordinator(e.target.value)
                            }
                          >
                            {programCoordinators?.map(
                              (programCoordinator, index) => (
                                <option
                                  key={index}
                                  value={programCoordinator.userId}
                                >
                                  {programCoordinator.name}
                                </option>
                              )
                            )}
                          </Form.Select>
                        </Col>
                      </Row>
                    )}
                    {userData.length > 0 && (
                      <Row>
                        <Col>
                          <TanstackTable data={userData} columns={columns} />
                        </Col>
                      </Row>
                    )}
                    <Row className="mt-4">
                      <Col>
                        <Button
                          onClick={() => setShowModal(true)}
                          as={Col}
                          variant="primary"
                        >
                          Add Users
                        </Button>
                        {error.userData && (
                          <div className="text-danger">{error.userData}</div>
                        )}
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                {success && (
                  <div className="alert alert-success">
                    User created successfully!
                  </div>
                )}

                <div className="d-flex justify-content-end">
                  <Link
                    to="/user-groups"
                    className="btn btn-outline-primary me-2"
                  >
                    Cancel
                  </Link>
                  <Button to="/users/" variant="primary" type="submit">
                    {loading ? "Saving..." : "Create"}
                  </Button>
                </div>
              </Form>
            </Col>
            <Col></Col>
          </Row>
        </>
      )}

      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Upload Excel File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="d-flex align-items-center">
              <Form.Group className="">
                <Form.Control
                  type="file"
                  accept=".xls,.xlsx"
                  onChange={handleFileChange}
                />
                {error.uploadError && (
                  <div className="text-danger mt-2">{error.uploadError}</div>
                )}
              </Form.Group>
              <div className="mx-3">
                {downloadTemplateLoading ? (
                  <>
                    <CircularProgress />
                  </>
                ) : (
                  <>
                    <Tooltip title="Download Template">
                      <IconButton>
                        <CloudDownloadIcon
                          sx={{ width: 20, height: 20 }}
                          onClick={downloadTemplate}
                        />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
              </div>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border">
          <Button variant="secondary" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleBulkUser}
            disabled={isLoading}
          >
            {isLoading ? "Uploading..." : "Upload"}
          </Button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
};

export default AddUserGroup;
